import(/* webpackMode: "eager" */ "/vercel/path0/src/app/charts/page.tsx");
